import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <div className="footer-brand">
      <a href="/" className="footer-logo">
        <img src={`${process.env.PUBLIC_URL}/assets/pawprints_logo.png`} alt="PawPrints" />
        pawprints
      </a>
      {/* <span>A small studio. Two dogs. Built in Brooklyn.</span> */}
    </div>
    <div className="footer-links">
      <Link to="/privacy">Privacy</Link>
      <Link to="/terms">Terms</Link>
      <Link to="/cookies">Cookies</Link>
      <button onClick={() => {}}>Support</button>
    </div>
  </footer>
);

export default Footer;
